/*
	Atualiza as infos do nosso oidc user
*/
export default (state, { user }) => {
	state.oidc.ready 	= user !== null 
	state.oidc.user 	= user
}